// extracted by mini-css-extract-plugin
export default {"inputArray":"form_inputArray__47x50","list":"form_list__A-gAv"};